import cx from "classnames";
import React, { Fragment } from "react";
import { FormattedHTMLMessage } from "react-intl";
import { IconSeat } from "@trainline/depot-web";
import PassengerType from "../../types/PassengerType";
import { SeatClass } from "../../types/SeatReservation";
import * as s from "./SeatReservations.module.css";
const EuSeatReservations = ({ seatReservations }) => {
  return /* @__PURE__ */ React.createElement("section", {
    className: s.container
  }, /* @__PURE__ */ React.createElement("section", {
    className: cx(s.icon, { [s.baselineIcon]: seatReservations.length > 1 })
  }, /* @__PURE__ */ React.createElement(IconSeat, null)), /* @__PURE__ */ React.createElement("div", {
    className: s.seatGrid
  }, seatReservations.map((seatReservation) => {
    const {
      seatNumber,
      seatingOptions,
      compartment,
      seatClass,
      passengerName,
      passengerType
    } = seatReservation;
    if (!seatNumber || !compartment) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Fragment, {
      key: `seatReservation-${seatNumber}`
    }, passengerName && /* @__PURE__ */ React.createElement("span", {
      className: s.passengerName
    }, passengerName, passengerType !== PassengerType.Adult && passengerType !== PassengerType.adult && ` (${String(passengerType)})`), /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement(FormattedHTMLMessage, {
      id: seatClass === SeatClass.STANDARD ? "seatReservation.standardClass" : "seatReservation.firstClass"
    }), /* @__PURE__ */ React.createElement(FormattedHTMLMessage, {
      id: "seatReservation.euCarriage",
      values: { carriage: compartment.identifier }
    }), /* @__PURE__ */ React.createElement("span", null, " \u2022 ", seatNumber), seatingOptions && /* @__PURE__ */ React.createElement("span", null, " (", seatingOptions, ")")));
  })));
};
var EuSeatReservations_default = EuSeatReservations;
export {
  EuSeatReservations_default as default
};
